import $ from "jquery";
import { OUTLINE_WRAPPER_SELECTOR } from "../4-one-of-one/_selectors";
import { OUTLINE_REMOVE_BUTTON } from "../constants/selectors";

function hideOutline() {
	try {
		$(OUTLINE_REMOVE_BUTTON).trigger("click");
	} catch (error) {
		console.log("hideOutline remove button, error", error);
	}
	try {
		$(OUTLINE_WRAPPER_SELECTOR).hide();
	} catch (error) {
		console.log("hideOutline outline wrapper, error", error);
	}
}

export default hideOutline;
